import { fromJS, is } from 'immutable'
import { isWkkfView } from '../../utils'
import { POINT_LAYERS } from '../../../../../constants/map'
// import { } from './../../../../../constants/map'

/**
 * Return object of map sources, one for each
 * point tileset, and one for the shapes tileset.
 * @param  {String} mapboxUser  Mapbox username
 * @param  {String} mapboxToken Mapbox api token
 * @param  {String} loadYears   Years of data to load for potential use
 * @param  {String} dataVersion   Years of data to load for potential use
 * @return {Object}
 */
export const getSources = (
  mapboxUser,
  mapboxToken,
  activeYear,
  dataVersion,
  activeView, // TODO: update when WKKF uses same years
) => {
  const versionStr = dataVersion.replace(/\./g, '-')
  const obj = {
    // clickable states & metros
    ddkids_shapes: {
      url: `mapbox://${mapboxUser}.shapes_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    },
    ddkids_tracts: {
      url: `mapbox://${mapboxUser}.tracts${activeYear}_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    },
    ddkids_zips: {
      url: `mapbox://${mapboxUser}.zips${activeYear}_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    },
    ddkids_counties: {
      url: `mapbox://${mapboxUser}.counties${activeYear}_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    },
    ddkids_redlining: {
      // todo: set with versionStr after uploading through etl
      url: `mapbox://${mapboxUser}.8qr9u2md?access_token=${mapboxToken}`,
      type: 'vector',
    },
    // clickable POI shapes
    ddkids_poi_shapes: {
      url: `mapbox://${mapboxUser}.poi_shapes_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    },
  }

  // regular demographic points and WKKF demographic points, which will be used only if WKKF mode active
  const pointSourceLayers = [
    ...POINT_LAYERS,
    ...POINT_LAYERS.map(l => `wkkf_${l}`),
  ]
  pointSourceLayers.forEach(layer => {
    obj[`ddkids_points_${layer}_${activeYear}`] = {
      url: `mapbox://${mapboxUser}.points_${layer}_${activeYear}_${versionStr}?access_token=${mapboxToken}`,
      type: 'vector',
    }
  })

  // console.log('source object: ', obj)
  return fromJS(obj)
}
